import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/axios";
import { API_ROUTES } from "./routes";
import { showToast } from "../components/ui/toast";

export const useGetLegalDocumentsQuery = () => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_LEGAL_DOCUMENTS],
    queryFn: () => api.get(API_ROUTES.GET_LEGAL_DOCUMENTS),
  });
  return { data: data?.data?.data ?? [], isPending, isError, error };
};

export const useGetLegalDocumentByIdQuery = (id) => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_LEGAL_DOCUMENT_BY_ID, id],
    queryFn: () => api.get(`${API_ROUTES.GET_LEGAL_DOCUMENT_BY_ID.replace(':id', id)}`),
    enabled: !!id,
  });
  return { data: data?.data?.data ?? null, isPending, isError, error };
};

export const useCreateLegalDocumentMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isLoading, isSuccess, isPending } =
    useMutation({
      mutationFn: (formData) =>
        api.post(API_ROUTES.CREATE_LEGAL_DOCUMENT, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        }),
      onSuccess: () => {
        showToast("success", "Legal document created successfully");
      },
      onSettled: () => {
        queryClient.invalidateQueries(API_ROUTES.GET_LEGAL_DOCUMENTS);
      },
    });
  return { mutate, isError, error, isLoading, isSuccess, isPending };
};

export const useUpdateLegalDocumentMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isLoading, isSuccess, isPending } =
    useMutation({
      mutationFn: ({ id, formData }) =>
        api.put(`${API_ROUTES.UPDATE_LEGAL_DOCUMENT}/${id}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        }),
      onSuccess: () => {
        showToast("success", "Legal document updated successfully");
      },
      onSettled: () => {
        queryClient.invalidateQueries(API_ROUTES.GET_LEGAL_DOCUMENTS);
      },
    });
  return { mutate, isError, error, isLoading, isSuccess, isPending };
};

export const useDeleteLegalDocumentMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isLoading, isSuccess, isPending } =
    useMutation({
      mutationFn: (id) => api.delete(`${API_ROUTES.DELETE_LEGAL_DOCUMENT.replace(':id', id)}`),
      onSuccess: () => {
        showToast("success", "Legal document deleted successfully");
      },
      onSettled: () => {
        queryClient.invalidateQueries(API_ROUTES.GET_LEGAL_DOCUMENTS);
      },
    });
  return { mutate, isError, error, isLoading, isSuccess, isPending };
};